import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertTriangle, Package } from 'lucide-react';
import {
  calculateInventoryCoverage,
  PRODUCTION_TIMELINE,
} from '../../data/mockData';

export function InventoryAlertsCard() {
  const coverage = calculateInventoryCoverage();
  const coveragePercent = Math.round(
    (coverage.unitsCanProduce / coverage.forecastedDemand) * 100,
  );
  const hasShortfall = coverage.shortfall > 0;

  return (
    <Card className={hasShortfall ? 'border-destructive' : ''}>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">Inventory Status</CardTitle>
        {hasShortfall ? (
          <AlertTriangle className="h-4 w-4 text-destructive" />
        ) : (
          <Package className="h-4 w-4 text-muted-foreground" />
        )}
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">
          {coverage.unitsCanProduce.toLocaleString()} units
        </div>
        <p className="text-xs text-muted-foreground mb-3">
          Production capacity with current inventory
        </p>

        {/* Progress bar */}
        <div className="w-full bg-secondary rounded-full h-2 mb-2">
          <div
            className={`h-2 rounded-full ${
              coveragePercent >= 100
                ? 'bg-green-500'
                : coveragePercent >= 50
                  ? 'bg-yellow-500'
                  : 'bg-destructive'
            }`}
            style={{ width: `${Math.min(coveragePercent, 100)}%` }}
          />
        </div>
        <div className="flex justify-between text-xs text-muted-foreground mb-3">
          <span>{coveragePercent}% of forecast covered</span>
          <span>Target: {coverage.forecastedDemand.toLocaleString()}</span>
        </div>

        {hasShortfall && (
          <div className="rounded-md bg-destructive/10 p-3 text-sm">
            <div className="flex items-center gap-2 text-destructive font-medium">
              <AlertTriangle className="h-4 w-4" />
              Shortfall: {coverage.shortfall.toLocaleString()} units
            </div>
            {coverage.bottleneckItem && (
              <p className="text-muted-foreground mt-1 text-xs">
                Bottleneck: {coverage.bottleneckItem.name}
              </p>
            )}
          </div>
        )}

        <div className="mt-3 pt-3 border-t">
          <p className="text-xs text-muted-foreground">
            <strong>Timeline:</strong>{' '}
            {PRODUCTION_TIMELINE.averageLeadTimeWeeks}w lead +{' '}
            {PRODUCTION_TIMELINE.manufacturingWeeks}w mfg +{' '}
            {PRODUCTION_TIMELINE.shippingWeeks}w ship ={' '}
            <span className="font-semibold">
              {PRODUCTION_TIMELINE.totalWeeks} weeks total
            </span>
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
